import { atom } from "recoil";

export const TestDriveBannerAtom = atom<{
  show: boolean;
  testDriveExpiration: number;
}>({
  key: "TestDriveBanner",
  default: {
    show: false,
    testDriveExpiration: 0,
  },
});
